import React, { useState } from 'react';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    Header,
    Subtitle,
    MainContainerItems,
    CollapsableHeader,
} from '../ShipAndTrack.styled';
import {
    DetailsMainContainerBlock,
    Title,
} from 'src/pages/orders/components/orderDetails/replenRequest/ReplenRequest.styled';

import ItemsInShipment from 'src/pages/orders/components/orderDetails/shipAndTrack/itemsInShipment/ItemsInShipment';
import TrackingNumberLabel from 'src/common/components/orderDetails/trackingNumberLabel/TrackingNumberLabel';
import Highlighter from 'react-highlight-words';
import { ShipTrackLabels } from 'src/constants/orderListConstants';

const ShipAndTrackDetails = (props) => {
    const {
        details,
        searchText,
        handleSetItemClick,
        ordersList,
        isLanguageChanged,
    } = props;
    const [expandedCard, setExpandedCard] = useState(true);
    const toggleCard = () => {
        setExpandedCard(!expandedCard);
    };

    const textHighlightedWords = (data) => {
        return (
            <Highlighter
                searchWords={searchText}
                autoEscape={true}
                textToHighlight={data}
            />
        );
    };

    const trackingNumber =
        details?.trackingNoAndUrl && details?.trackingNoAndUrl?.entry
            ? details?.trackingNoAndUrl?.entry[0]?.key
            : null;
    const title =
        details?.carrier && trackingNumber
            ? `${details.carrier} # ${trackingNumber}`
            : details?.carrier
            ? details.carrier
            : trackingNumber
            ? trackingNumber
            : null;

    const accountDetails =
        details?.shipTo && details?.shipToAccName
            ? details.shipToAccName +
              ' ' +
              details.shipTo.toString().replace(/^0+/, '')
            : details?.shipTo
            ? details.shipTo.toString().replace(/^0+/, '')
            : details?.shipToAccName
            ? details.shipToAccName
            : null;

    return (
        <>
            <CollapsableCard
                id="orders-shipAndTrackDetails-shipAndTrackDetails-shipmentDetails"
                title={
                    title ? (
                        textHighlightedWords(title)
                    ) : (
                        <CollapsableHeader>
                            {textHighlightedWords(ShipTrackLabels().tbdTitle)}
                        </CollapsableHeader>
                    )
                }
                // title={"ABC"}
                onClick={toggleCard}
                isExpanded={expandedCard}
                padding={'16px'}
                key={details.deliveryNo}
                cursor={'pointer'}
                currentActivity
            >
                {expandedCard ? (
                    <DetailsMainContainerBlock>
                        {details?.trackingNoAndUrl?.entry && (
                            <>
                                <MainContainerItems
                                    width={'100%'}
                                    marginBottom={'16px'}
                                    smPadding={'0px'}
                                >
                                    {details?.trackingNoAndUrl?.entry ? (
                                        <TrackingNumberLabel
                                            trackingDetails={
                                                details.trackingNoAndUrl.entry
                                            }
                                            isHighlight={true}
                                            textHighlightedWords={
                                                textHighlightedWords
                                            }
                                        />
                                    ) : null}
                                </MainContainerItems>
                            </>
                        )}
                        {details?.shippedOn && (
                            <>
                                <MainContainerItems
                                    marginBottom={'16px'}
                                    smPadding={'0px'}
                                >
                                    <Title color={'#202124'} fontSize={'14px'}>
                                        {' '}
                                        {textHighlightedWords(
                                            ShipTrackLabels()['shippedOn']
                                        )}
                                    </Title>
                                    <Subtitle
                                        width="100%"
                                        color={'#202124'}
                                        fontSize={'15px'}
                                    >
                                        {textHighlightedWords(
                                            props.dateFormatter(
                                                details.shippedOn,
                                                true
                                            )
                                        )}
                                    </Subtitle>
                                </MainContainerItems>
                            </>
                        )}
                        {accountDetails ? (
                            <MainContainerItems
                                marginBottom={'16px'}
                                smPadding={'0px'}
                            >
                                <Title
                                    color={'#202124'}
                                    fontSize={'14px'}
                                    display={isLanguageChanged && 'flex'}
                                >
                                    {' '}
                                    {textHighlightedWords(
                                        ShipTrackLabels()['shippedToLabel']
                                    )}
                                    {isLanguageChanged && (
                                        <Title
                                            color={'#ED002A'}
                                            fontSize={'14px'}
                                        >
                                            {textHighlightedWords(
                                                ShipTrackLabels()[
                                                    'shippedToLabelInformation'
                                                ]
                                            )}
                                        </Title>
                                    )}
                                </Title>
                                <Subtitle
                                    className="order-ship-and-track-recipient-dt-mask"
                                    color={'#202124'}
                                    width="90%"
                                    fontSize={'15px'}
                                >
                                    {textHighlightedWords(accountDetails)}{' '}
                                </Subtitle>
                            </MainContainerItems>
                        ) : null}
                        {details?.deliveryNo && (
                            <>
                                <MainContainerItems
                                    marginBottom={'16px'}
                                    smPadding={'0px'}
                                >
                                    <Title color={'#202124'} fontSize={'14px'}>
                                        {' '}
                                        {textHighlightedWords(
                                            ShipTrackLabels()['deliveryNo']
                                        )}
                                    </Title>
                                    <Subtitle
                                        color={'#202124'}
                                        width="70%"
                                        fontSize={'15px'}
                                    >
                                        {textHighlightedWords(
                                            details.deliveryNo
                                        )}
                                    </Subtitle>
                                </MainContainerItems>
                            </>
                        )}
                        {details?.plant && (
                            <>
                                <MainContainerItems
                                    marginBottom={'16px'}
                                    smPadding={'0px'}
                                >
                                    <Title color={'#202124'} fontSize={'14px'}>
                                        {' '}
                                        {textHighlightedWords(
                                            ShipTrackLabels()['plant']
                                        )}
                                    </Title>
                                    <Subtitle
                                        color={'#202124'}
                                        width="70%"
                                        fontSize={'15px'}
                                    >
                                        {textHighlightedWords(details.plant)}
                                    </Subtitle>
                                </MainContainerItems>
                            </>
                        )}
                        {details?.freightType && (
                            <>
                                <MainContainerItems
                                    marginBottom={'16px'}
                                    smPadding={'0px'}
                                >
                                    <Title color={'#202124'} fontSize={'14px'}>
                                        {' '}
                                        {textHighlightedWords(
                                            ShipTrackLabels()['freightType']
                                        )}
                                    </Title>
                                    <Subtitle
                                        color={'#202124'}
                                        width="90%"
                                        fontSize={'15px'}
                                    >
                                        {textHighlightedWords(
                                            details.freightType
                                        )}
                                    </Subtitle>
                                </MainContainerItems>
                            </>
                        )}
                        {details?.lastUpdated && (
                            <>
                                <MainContainerItems
                                    marginBottom={'16px'}
                                    smPadding={'0px'}
                                >
                                    <Title color={'#202124'} fontSize={'14px'}>
                                        {' '}
                                        {textHighlightedWords(
                                            ShipTrackLabels()['lastUpdated']
                                        )}
                                    </Title>
                                    <Subtitle
                                        color={'#202124'}
                                        width="85%"
                                        fontSize={'15px'}
                                    >
                                        {textHighlightedWords(
                                            props.dateFormatter(
                                                details.lastUpdated,
                                                false
                                            )
                                        )}
                                    </Subtitle>
                                </MainContainerItems>
                            </>
                        )}
                        {details?.products && details?.products.length > 0 ? (
                            <>
                                <Header>
                                    {textHighlightedWords(
                                        ShipTrackLabels()['productsTitle']
                                    )}
                                </Header>
                                <ItemsInShipment
                                    productsDetails={details.products}
                                    searchText={searchText}
                                    handleSetItemClick={handleSetItemClick}
                                    ordersList={ordersList}
                                    isOrderType={true}
                                    isConsignmentReturn={
                                        ordersList?.currentOrderType === 'ZKA'
                                    }
                                />
                            </>
                        ) : null}
                    </DetailsMainContainerBlock>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default ShipAndTrackDetails;
